import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Constants } from 'src/app/app.constants';
import { ErrorHandleService } from './error-handle.service';

@Injectable({
    providedIn: 'root',
})
export class MasterdataService {
    masterdata = new Subject<any>();

    constructor(
        private http: HttpClient,
        private errorHandleService: ErrorHandleService,
        private constants: Constants
    ) {}

    getMasterData(): Observable<any> {
        const uri = decodeURIComponent(
            `${this.constants.apiUrl}/Home/getmasterdata`
        );
        return this.http.get<any>(uri).pipe(
            tap((_) => console.log('fetching master data')),
            catchError(
                this.errorHandleService.handleError('getMasterData', [])
            ),
            finalize(() => console.log('Loaded: Master data'))
        );
    }

    getDBUpdate(): Observable<any> {
        const uri = decodeURIComponent(
            `${this.constants.apiUrl}/Home/getdbmigrationupdate`
        );
        return this.http.get<any>(uri).pipe(
            tap((_) => console.log('fetching last update time')),
            catchError(this.errorHandleService.handleError('getDBUpdate', [])),
            finalize(() => console.log('Loaded: Last update data'))
        );
    }
}
